export type StandAloneState = {
  importId: number | null,
  importDetailId: number | null,
  containerType?: number | null,
  fileName: string,
  fileType: FileType | null;
  status: Status | null,
  page: number,
  serverPage: number,
  serverPageChange: boolean | null,
  taxTableIndex: number,
  taxTableIndexChange: boolean | null,
  filterData: any,
  applyFilterClick: boolean,
  importFilesData: any | null
};

export type Action = {
  type: StandAloneActions | null
  payload?: any;
};

export enum StandAloneActions {
  LOADING,
  SET_SELECTED_FILE,
  SET_IMPORT_DETAIL,
  SET_MAIN_PAGE,
  SET_TAX_PAGE,
  SET_FILTER_DATA,
  RESET_PAGING_AND_SEARCH,
  SEARCH,
  PAGING,
}

export enum Status
{
    Validating,
    Aggregating,
    Transmitting,
    Completed,
    Error,
    TransmissionError
}

export enum FileType
{
    Pay = 0,
    ROE = 1,
    T4_Original = 2,
    T4A_Original = 3,
    T4_Amended = 4,
    T4A_Amended = 5,
    Unknown = 6
}

export enum YearEndContainerTypeDefaults
{
    Unclassified = 0,
    T4 = 1,
    T4A = 2,
    NR4 = 3,
    RL1 = 4,
    RL2 = 5,  
}

export enum YearEndSubmissionTypeDefaults
{
    Unclassified = 0,
    Original = 1,
    Amended = 2,
    Cancelled = 3
}

export const ContainerTypeDisplayName: Record<YearEndContainerTypeDefaults, string> =
{
    [YearEndContainerTypeDefaults.Unclassified]: "Unclassified",
    [YearEndContainerTypeDefaults.T4]: "T4",
    [YearEndContainerTypeDefaults.T4A]: "T4A",
    [YearEndContainerTypeDefaults.NR4]: "NR4",  
    [YearEndContainerTypeDefaults.RL1]: "RL1",
    [YearEndContainerTypeDefaults.RL2]: "RL2",
};

export const SubmissionTypeDisplayName: Record<YearEndSubmissionTypeDefaults, string> =
{
    [YearEndSubmissionTypeDefaults.Unclassified]: "Unclassified",
    [YearEndSubmissionTypeDefaults.Original]: "Original",
    [YearEndSubmissionTypeDefaults.Amended]: "Amended",
    [YearEndSubmissionTypeDefaults.Cancelled]: "Cancelled"
};

export const FileTypeDisplayName: Record<FileType, string> = {
    [FileType.Pay]: "Pay",
    [FileType.ROE]: "ROE",
    [FileType.T4_Original]: "T4 - Original",
    [FileType.T4A_Original]: "T4A - Original",
    [FileType.T4_Amended]: "T4 - Amended",
    [FileType.T4A_Amended]: "T4A - Amended",
    [FileType.Unknown]: "Unknown"
};

export enum IsProduction 
{
  true = "Prod",
  false = "Test"
}
